function normalizeCountryName(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
}

const countryNameToIso2: Record<string, string> = {
  afghanistan: 'af',
  albania: 'al',
  algeria: 'dz',
  andorra: 'ad',
  angola: 'ao',
  antiguaandbarbuda: 'ag',
  argentina: 'ar',
  armenia: 'am',
  australia: 'au',
  austria: 'at',
  azerbaijan: 'az',
  bahamas: 'bs',
  bahrain: 'bh',
  bangladesh: 'bd',
  barbados: 'bb',
  belarus: 'by',
  belgium: 'be',
  belize: 'bz',
  benin: 'bj',
  bhutan: 'bt',
  bolivia: 'bo',
  bosniaandherzegovina: 'ba',
  botswana: 'bw',
  brazil: 'br',
  brunei: 'bn',
  bulgaria: 'bg',
  burkinafaso: 'bf',
  burundi: 'bi',
  cambodia: 'kh',
  cameroon: 'cm',
  canada: 'ca',
  capeverde: 'cv',
  caymanislands: 'ky',
  centralafricanrepublic: 'cf',
  chad: 'td',
  chile: 'cl',
  china: 'cn',
  colombia: 'co',
  comoros: 'km',
  congo: 'cg',
  democraticrepublicofthecongo: 'cd',
  costarica: 'cr',
  cotedivoire: 'ci',
  croatia: 'hr',
  cuba: 'cu',
  cyprus: 'cy',
  czechia: 'cz',
  czechrepublic: 'cz',
  denmark: 'dk',
  djibouti: 'dj',
  dominica: 'dm',
  dominicanrepublic: 'do',
  ecuador: 'ec',
  egypt: 'eg',
  elsalvador: 'sv',
  equatorialguinea: 'gq',
  eritrea: 'er',
  estonia: 'ee',
  eswatini: 'sz',
  ethiopia: 'et',
  fiji: 'fj',
  finland: 'fi',
  france: 'fr',
  gabon: 'ga',
  gambia: 'gm',
  georgia: 'ge',
  germany: 'de',
  ghana: 'gh',
  greece: 'gr',
  grenada: 'gd',
  guatemala: 'gt',
  guinea: 'gn',
  guineabissau: 'gw',
  guyana: 'gy',
  haiti: 'ht',
  honduras: 'hn',
  hungary: 'hu',
  iceland: 'is',
  india: 'in',
  indonesia: 'id',
  iran: 'ir',
  iraq: 'iq',
  ireland: 'ie',
  israel: 'il',
  italy: 'it',
  jamaica: 'jm',
  japan: 'jp',
  jordan: 'jo',
  kazakhstan: 'kz',
  kenya: 'ke',
  kiribati: 'ki',
  kuwait: 'kw',
  kyrgyzstan: 'kg',
  laos: 'la',
  latvia: 'lv',
  lebanon: 'lb',
  lesotho: 'ls',
  liberia: 'lr',
  libya: 'ly',
  liechtenstein: 'li',
  lithuania: 'lt',
  luxembourg: 'lu',
  madagascar: 'mg',
  malawi: 'mw',
  malaysia: 'my',
  maldives: 'mv',
  mali: 'ml',
  malta: 'mt',
  marshallislands: 'mh',
  mauritania: 'mr',
  mauritius: 'mu',
  mexico: 'mx',
  micronesia: 'fm',
  moldova: 'md',
  monaco: 'mc',
  mongolia: 'mn',
  montenegro: 'me',
  morocco: 'ma',
  mozambique: 'mz',
  myanmar: 'mm',
  namibia: 'na',
  nauru: 'nr',
  nepal: 'np',
  netherlands: 'nl',
  newzealand: 'nz',
  nicaragua: 'ni',
  niger: 'ne',
  nigeria: 'ng',
  northkorea: 'kp',
  northmacedonia: 'mk',
  norway: 'no',
  oman: 'om',
  pakistan: 'pk',
  palau: 'pw',
  palestine: 'ps',
  panama: 'pa',
  papuanewguinea: 'pg',
  paraguay: 'py',
  peru: 'pe',
  philippines: 'ph',
  poland: 'pl',
  portugal: 'pt',
  qatar: 'qa',
  romania: 'ro',
  russia: 'ru',
  rwanda: 'rw',
  saintkittsandnevis: 'kn',
  saintlucia: 'lc',
  saintvincentandthegrenadines: 'vc',
  samoa: 'ws',
  sanmarino: 'sm',
  saotomeandprincipe: 'st',
  saudiarabia: 'sa',
  senegal: 'sn',
  serbia: 'rs',
  seychelles: 'sc',
  sierraleone: 'sl',
  singapore: 'sg',
  slovakia: 'sk',
  slovenia: 'si',
  solomonislands: 'sb',
  somalia: 'so',
  southafrica: 'za',
  southkorea: 'kr',
  southsudan: 'ss',
  spain: 'es',
  srilanka: 'lk',
  sudan: 'sd',
  suriname: 'sr',
  sweden: 'se',
  switzerland: 'ch',
  syria: 'sy',
  tajikistan: 'tj',
  tanzania: 'tz',
  thailand: 'th',
  timorleste: 'tl',
  togo: 'tg',
  tonga: 'to',
  trinidadandtobago: 'tt',
  tunisia: 'tn',
  turkey: 'tr',
  turkmenistan: 'tm',
  tuvalu: 'tv',
  uganda: 'ug',
  ukraine: 'ua',
  unitedarabemirates: 'ae',
  unitedkingdom: 'gb',
  unitedstates: 'us',
  unitedstatesofamerica: 'us',
  uruguay: 'uy',
  uzbekistan: 'uz',
  vanuatu: 'vu',
  vaticancity: 'va',
  venezuela: 've',
  vietnam: 'vn',
  yemen: 'ye',
  zambia: 'zm',
  zimbabwe: 'zw',
  alandislands: 'ax',
}

export function getCountryIso2FromName(countryName: string | null | undefined): string | undefined {
  if (!countryName) {
    return undefined
  }

  const normalized = normalizeCountryName(countryName)

  if (!normalized) {
    return undefined
  }

  const directMatch = countryNameToIso2[normalized]

  if (directMatch) {
    return directMatch
  }

  const compressed = normalized.replace(/\s+/g, '')

  return countryNameToIso2[compressed]
}
